var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4375 11.4378C12.1407 10.7348 13.0944 10.3398 14.0887 10.3398C15.0831 10.3398 16.0368 10.7348 16.74 11.4378L30 24.6978L43.26 11.4378C43.9672 10.7547 44.9145 10.3767 45.8977 10.3853C46.881 10.3938 47.8215 10.7882 48.5168 11.4835C49.2121 12.1788 49.6065 13.1193 49.615 14.1025C49.6236 15.0858 49.2456 16.033 48.5625 16.7403L35.3025 30.0003L48.5625 43.2603C49.2456 43.9676 49.6236 44.9148 49.615 45.898C49.6065 46.8813 49.2121 47.8218 48.5168 48.5171C47.8215 49.2124 46.881 49.6068 45.8977 49.6153C44.9145 49.6239 43.9672 49.2459 43.26 48.5628L30 35.3028L16.74 48.5628C16.0327 49.2459 15.0855 49.6239 14.1022 49.6153C13.119 49.6068 12.1784 49.2124 11.4832 48.5171C10.7879 47.8218 10.3935 46.8813 10.385 45.898C10.3764 44.9148 10.7544 43.9676 11.4375 43.2603L24.6975 30.0003L11.4375 16.7403C10.7345 16.0371 10.3395 15.0834 10.3395 14.089C10.3395 13.0947 10.7345 12.141 11.4375 11.4378Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8f5a7a312b12fd9c2b4ab6b677367cfc.svg";
export { ForwardRef as ReactComponent };